<template>
  <Datetime v-model="dateInput"
            :id="id"
            :timezone="zone"
            :with-timezone="withTimezone"
            :disabled="!zone"
            :class="datetimeClass"
            type="datetime">
  </Datetime>
  <input type="hidden" :name="hiddenName" :value="dateInput">
</template>

<script>
import Datetime from "@/components/ui/Datetime.vue";

export default {
  components: { Datetime },
  props: {
    id: {
      type: String,
    },
    timezone: {
      type: String,
    },
    date : {
      default : null,
    },
    hiddenNameInput : {
      type : String,
    },
    datetimeClass: {
      type: String,
      default: '',
    },
    withTimezone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      zone: null,
      dateInput: null,
      hiddenName: '',
    }
  },
  created() {
    this.zone = this.timezone
    this.dateInput = this.date
    this.hiddenName = this.hiddenNameInput
  },
}
</script>

<style scoped>

</style>